// FirebaseChat.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase, ref, push, set, onValue, off, get, update } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAq1MbygHJu-4M61LoOqANbJZ4TjaqNVxE",
  authDomain: "fir-2ce45.firebaseapp.com",
  databaseURL: "https://fir-2ce45-default-rtdb.firebaseio.com",
  projectId: "fir-2ce45",
  storageBucket: "fir-2ce45.firebasestorage.app",
  messagingSenderId: "542544051197",
  appId: "1:542544051197:web:9282228b8d6d23ec9eb794"
};

// Initialize Firebase only if it hasn't been initialized already
// Initialize a named Firebase app for chat
const CHAT_APP_NAME = "chat-app";
const chatApp = initializeApp(firebaseConfig, CHAT_APP_NAME);
const database = getDatabase(chatApp);

export { database, ref, push, set, onValue, off, get, update };